import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FinancialYear } from '../entity/financialyear';
import { BLService } from './bl.service';

@Injectable()
export class FinancialYearService extends BLService {
  private RESOURCE_ENDPOINT = 'financial-year';

  getFinancialYearsForClientId(id: number): Observable<FinancialYear[]> {
    const queryParam = '?order=DESC';
    return this.httpGet<FinancialYear[]>(`${this.RESOURCE_ENDPOINT}/${id}${queryParam}`);
  }

  saveFinancialYear(financialYear: FinancialYear): Observable<FinancialYear> {
    const body = JSON.stringify(financialYear);

    return this.httpPut<FinancialYear>(this.RESOURCE_ENDPOINT, body);
  }

  addNextFinancialYear(clientId: number): Observable<FinancialYear> {
    return this.httpPut<FinancialYear>(`${this.RESOURCE_ENDPOINT}/next/${clientId}`, '');
  }

  deleteFinancialYearWithId(financialYearIdid: number): Observable<FinancialYear[]> {
    return this.httpDelete<FinancialYear[]>(`${this.RESOURCE_ENDPOINT}/${financialYearIdid}`);
  }
}
